module.exports = require('./function')()